export default function HeroSection() {
  return (
    <section className="relative bg-gradient-to-br from-emerald-50 via-white to-teal-50 py-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-emerald-100 rounded-full mb-6">
            <i className="ri-heart-pulse-line text-3xl text-emerald-600"></i>
          </div>
          <h1 className="text-5xl font-bold text-gray-900 mb-6" style={{fontFamily: '"Playfair Display", serif'}}>
            Wellness Blog
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed">
            Discover evidence-based insights on natural health, nutrition, holistic wellness, and sustainable living. 
            Your journey to optimal health starts with knowledge and mindful choices.
          </p>
        </div>
      </div>
    </section>
  );
}
